import { jsx as r } from "react/jsx-runtime";
import t from "../loader/Loader.js";
import { IconSize as i } from "../icon/types.js";
const p = ({ className: o }) => /* @__PURE__ */ r(t, { size: i.MD, className: o });
export {
  p as ButtonLoadingIndicator
};
